export default __webpack_public_path__ + "static/media/PNRR-wallpaper.06644298.jpg";